import { fetchWithTimeout } from '@mb/api';
import { loadUserData } from '@mb/lib';
import { handleSystemErrorReport } from '@mb/lib/utils';
import { config } from '../../config';
import {
  contentBlockXRequestIdSelector,
  xRequestIdSelector,
} from '../../redux/selectors/searchSelector';
import store from '../../redux/store';
import { getPayloadLang } from '../../utils/localstorage';

export interface AnalyticsRequestProps {
  id: string | string[];
  type: 'view' | 'cart' | 'share' | 'favorite' | 'rate';
  value?: string;
  customRequestId?: string;
  [key: string]: any;
  impressions?: string[];
  class?: string;
}

export const sendAnalytics = async (
  data: AnalyticsRequestProps,
  timeout: number = 3000,
) => {
  try {
    const { customRequestId, ...rest } = data;
    const xRequestId = xRequestIdSelector(store.getState());
    const contentBlockXRequestId = contentBlockXRequestIdSelector(
      store.getState(),
    );
    const response = fetchWithTimeout(config.endpoints.analytics, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      timeout: timeout,
      body: JSON.stringify({
        requestId: customRequestId || contentBlockXRequestId || xRequestId,
        ...rest,
      }),
    })
      .then((res) => res.json())
      .catch((e) => {
        console.log('sendAnalytics', e);
      });
    return response;
  } catch (e) {
    handleSystemErrorReport(
      `Error sendAnalytics: ${e.message}`,
      'sendAnalytics',
    );
    console.log('Error sendAnalytics:', e);
  }
};

interface AdhocRequestProps {
  id: string | string[];
  type: 'view' | 'cart' | 'share' | 'favorite' | 'rate' | 'select_value';
  action: string;
  value?: string;
  impressions: string[];
}

export const sendAdhocAnalytics = async (
  data: AdhocRequestProps,
  timeout: number = 3000,
) => {
  try {
    const xRequestId = xRequestIdSelector(store.getState());
    const userData = await loadUserData();
    const body = {
      sessionId: xRequestId,
      requestId: xRequestId,
      siteId: config.searchSpring.siteId,
      referrerUrl: window.location.host + window.location.pathname,
      customer: {
        email: userData?.email,
      },
      lang: getPayloadLang(),
      ...data,
    };
    const response = fetchWithTimeout(config.endpoints.adhoc, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      timeout: timeout,
      body: JSON.stringify(body),
    })
      .then((res) => res.json())
      .catch((e) => {
        console.log('send Adhoc Analytics', e);
      });
    return response;
  } catch (e) {
    handleSystemErrorReport(
      `Error sendAdhocAnalytics: ${e.message}`,
      'sendAdhocAnalytics',
    );
    console.log('Error send Adhoc Analytics:', e);
  }
};
